
import React from "react";

interface ResultsSummaryProps {
  count: number;
  searchQuery: string;
  selectedCounty: string | null;
  counties: { county: string; county_slug: string }[] | undefined;
}

export function ResultsSummary({ 
  count, 
  searchQuery, 
  selectedCounty, 
  counties 
}: ResultsSummaryProps) {
  return (
    <div className="mb-6">
      <p className="text-grandpal-gray">
        Found {count} nursing homes
        {searchQuery && ` matching "${searchQuery}"`}
        {selectedCounty && counties?.find(c => c.county_slug === selectedCounty)?.county && 
          ` in ${counties?.find(c => c.county_slug === selectedCounty)?.county}`}
      </p>
    </div>
  );
}
